import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'
  
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export function formatDuration(seconds) {
  if (seconds < 60) return `${Math.round(seconds)}s`
  if (seconds < 3600) return `${Math.round(seconds / 60)}m ${Math.round(seconds % 60)}s`
  return `${Math.round(seconds / 3600)}h ${Math.round((seconds % 3600) / 60)}m`
}

export function getBaseUrl() {
  // Use the backend server URL for API calls
  
  // In development (both local and Replit): Use Vite proxy (empty string means same origin)
  // In production: Backend and frontend run on the same port
  
  const isReplitDev = window.location.hostname.includes('.replit.dev') || 
                     window.location.hostname.includes('replit.com')
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  
  // If we're in development, use empty string (Vite proxy will handle routing)
  if (isLocal || isReplitDev) {
    return ''  // Empty string uses same origin, Vite proxy handles backend routing
  }
  
  // For production deployment, backend runs on the same port as frontend
  return `${window.location.protocol}//${window.location.host}`
}

export async function apiRequest(endpoint, options = {}) {
  const baseUrl = getBaseUrl()
  const url = `${baseUrl}${endpoint}`
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
  
  const finalOptions = { ...defaultOptions, ...options }
  
  // Remove Content-Type for FormData
  if (finalOptions.body instanceof FormData) {
    delete finalOptions.headers['Content-Type']
  }
  
  const response = await fetch(url, finalOptions)
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: response.statusText }))
    const error = new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`)
    // Attach the full error data for special handling (e.g., scanned PDF detection)
    error.data = errorData
    throw error
  }
  
  return response.json()
}